export enum SystemConfigKey {
	DIESEL_PRICE = 'DIESEL_PRICE',
	GASOLINE_PRICE = 'GASOLINE_PRICE',
	GPL_PRICE = 'GPL_PRICE',
	NATURAL_GAS_PRICE = 'NATURAL_GAS_PRICE',
	ELECTRICITY_PRICE = 'ELECTRICITY_PRICE',
}
